import { render, staticRenderFns } from "./StudyPlanHeader.vue?vue&type=template&id=63edebcd&"
import script from "./StudyPlanHeader.vue?vue&type=script&lang=js&"
export * from "./StudyPlanHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports